import React from 'react'

export const digitsOnlyFilterProps = () => ({
  mantineFilterTextInputProps: {
    onInput: (e: React.FormEvent<HTMLInputElement>) => {
      const target = e.target as HTMLInputElement
      target.value = target.value.replace(/\D/g, '')
    },
  },
})
